import { CourseListener as ICourseListener } from "@/api/models/course-listener";

export default {
  state: {
    listeners: [],
    selectedListeners: []
  },
  actions: {
    SETUP_LISTENERS(ctx: any, listeners: Array<ICourseListener>) {
      ctx.commit("SETUP_LISTENERS", listeners);
    },
    CHANGE_SELECTED_LISTENER(ctx: any, listener: ICourseListener) {
      ctx.commit("CHANGE_SELECTED_LISTENER", listener);
    },
    SELECT_ALL_LISTENERS(ctx: any) {
      ctx.commit("SELECT_ALL_LISTENERS");
    },
    CLEAR_LISTENER_TABLE_STATE(ctx: any) {
      ctx.commit("CLEAR_LISTENER_TABLE_STATE");
    },
    CLEAR_LISTENERS(ctx: any) {
      ctx.commit("CLEAR_LISTENERS");
    },
    SETUP_SELECTED_LISTENERS(ctx: any, listeners: Array<ICourseListener>) {
      ctx.commit("SETUP_SELECTED_LISTENERS", listeners);
    },
    ADD_LISTENERS(ctx: any, listeners: Array<ICourseListener>) {
      ctx.commit("ADD_LISTENERS", listeners);
    }
  },
  mutations: {
    SETUP_LISTENERS(state: any, listeners: Array<ICourseListener>) {
      state.listeners = listeners;
    },
    CHANGE_SELECTED_LISTENER(state: any, listener: ICourseListener) {
      if (state.selectedListeners.includes(listener)) {
        state.selectedListeners = state.selectedListeners.filter(
          (el: ICourseListener) => el.id !== listener.id
        );
      } else state.selectedListeners.push(listener);
    },
    SELECT_ALL_LISTENERS(state: any) {
      if (state.listeners.length !== state.selectedListeners.length) {
        state.selectedListeners = state.listeners;
      } else {
        state.selectedListeners = [];
      }
    },
    CLEAR_LISTENER_TABLE_STATE(state: any) {
      state.selectedListeners = [];
      state.listeners = [];
    },
    CLEAR_LISTENERS(state: any) {
      state.listeners = [];
    },
    SETUP_SELECTED_LISTENERS(state: any, listeners: Array<ICourseListener>) {
      state.selectedListeners = listeners;
    },
    ADD_LISTENERS(state: any, listeners: Array<ICourseListener>) {
      listeners.forEach(el => {
        state.listeners.push(el);
      });
    }
  },
  getters: {
    LISTENERS(state: any) {
      return state.listeners;
    },
    SELECTED_LISTENERS(state: any) {
      return state.selectedListeners;
    }
  }
};
